import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import styled from '@emotion/styled';
import ActivityLog from './ActivityLog';

const TaskContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    marginTop: theme.spacing(2),
    height: '100%',
}));

const BoxTitle = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    textAlign: 'left',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(3),
}));




const ProfileActivityBox = ( {userId, canSeeInternal=false} ) => {

    return (
        <Grid item xs={12} md={canSeeInternal ? 8 : 12} lg={canSeeInternal ? 8 : 12}>
            <TaskContainer>
            <BoxTitle variant="h5">Recent Activity</BoxTitle>
            <ActivityLog objectId={userId} objectType="user" />
            </TaskContainer>
        </Grid>
    );
};

export default ProfileActivityBox;